import dayjs from "dayjs";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/ca";
import advancedFormat from "dayjs/plugin/advancedFormat";

export const getFormattedBySlashesDate = stringDate =>
  dayjs(new Date(stringDate)).format("DD/MM/YYYY");

export const dateWrappers = {
  /**
   * Returns today Date, Use this so that you will be able to mock it in unit test
   * @example
   * // USE IN PRODUCTION CODE:
   *  import {dateWrappers} from '../utils/date-utils.js';
   *
   *  const today = dateWrappers.getDate();
   *
   * // HOW TO MOCK IN TESTS:
   * import { dateWrappers } from '../utils/date-utils.js';
   *
   * let originalDateWrappersGetDate;
   * beforeEach(() => {
   * 	originalDateWrappersGetDate = dateWrappers.getDate;
   * 	dateWrappers.getDate = () => new Date('2010-10-20');
   * });
   * afterEach(() => {
   * 	dateWrappers.getDate = originalDateWrappersGetDate;
   * });
   *
   * @returns {Date}
   */
  getDate: (date = Date.now()) => new Date(date),

  /**
   * Returns the current time in miliseonds
   * @returns {number}
   */
  getNow: () => Date.now(),

  setHours: (date, hour) => {
    date.setHours(hour);
    return date;
  },

  setMinutes: (date, minutes) => {
    date.setMinutes(minutes);
    return date;
  }
};

export const isToday = someDate => {
  const today = new Date();
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
};

export const allDayTimeSlot = {
  start_time: 9,
  end_time: 18
};

export const getDateFromFormat = date => {
  return date && date.length > 0 && date.split("/").reverse().join("/");
};

export const getDateTime = date => {
  const currentDate = new Date(date);
  const currentHour = currentDate.getHours();
  const currentMinutes = currentDate.getMinutes();
  return `${currentHour}:${
    currentMinutes < 10 ? "0" : ""
  }${currentMinutes.toString()}`;
};

export const setTimeOnDate = ({ hour, minutes = "00", date }) => {
  const dateOption = date ? new Date(date) : new Date();
  dateOption.setHours(+hour);
  dateOption.setMinutes(minutes);
  dateOption.setSeconds(0);
  dateOption.setMilliseconds(0);
  return dateOption;
};

export const setDayOnDate = ({ date, newDate }) => {
  const dayWithNewDay = new Date(date);
  dayWithNewDay.setDate(newDate.getDate());
  dayWithNewDay.setMonth(newDate.getMonth());
  dayWithNewDay.setFullYear(newDate.getFullYear());
  return dayWithNewDay;
};

export const getTranslatedDate = (timestamp, language = "en-GB") => {
  dayjs.extend(advancedFormat);
  let suggestedDate = dayjs(new Date(timestamp)).locale(language);
  switch (language) {
    case "ca":
      suggestedDate = suggestedDate.format("dddd, D [de] MMMM YYYY");
      const months = ["Abril", "Agost", "Octubre"];
      if (months.find(month => suggestedDate.includes(month))) {
        return suggestedDate.replace(" de ", " d'");
      }
      return suggestedDate;
    case "es":
      return suggestedDate.format("dddd, D [de] MMMM YYYY");
    default:
      return suggestedDate.format("dddd, Do MMMM YYYY");
  }
};
